import React from "react"

export default function ExternalLink(props) {
  return (
    <a rel="noopener noreferrer" href={props.href} target="_blank">
      {props.label ? props.label : props.href}
    </a>
  )
}
